import React, { useState } from 'react';
import ModalCommon from "../../ModalCommon";
import { Row, Col } from "olive-react-myoneui";
import Form from "olive-react-myoneui/lib/Form";
import Button from "olive-react-myoneui/lib/Button";

const ModalFolder = ({ showModal, closeModal, folderDetail, updateDocument }) => {

    const [formData, setFormData] = useState({
        itemName: folderDetail.itemName,
        itemShortDesc: folderDetail.itemFolderShortDescription
    });
    const [nameErrorMessage, setNameErrorMessage] = useState('');
    const [descriptionErrorMessage, setDescriptionErrorMessage] = useState('');

    if(!showModal) return null;

    const handleInputChange = (e) => {
        const {name, value} =  e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        if(name === "itemName") {
            setNameErrorMessage("");
            if(value === ""){
                setNameErrorMessage('Folder name is required');
            }
        }
        if(name === "itemShortDesc") {
            setDescriptionErrorMessage('');
            if(value === ""){
                setDescriptionErrorMessage("Description is required");
            }
        }
    };


    const handleSave =  (e) => {
        e.preventDefault();
        if(nameErrorMessage !== '' || descriptionErrorMessage !== ''){
            return;
        }
        formData.itemType       = '0';
        updateDocument(formData, folderDetail);
    }

    return (
        <ModalCommon
            backdrop="static"
            show={showModal}
            onClose={closeModal}
            title="Folder Details"
            className="myk__stu-question-modal"
            backdropOption="static"
        >
            <Form>
                <Row>
                    <Col className="text-start">
                        <Form.Group className="mb-3" controlId="formGroupEmail">
                            <Form.Label>Folder Name</Form.Label>
                            <Form.Control type="text" name="itemName" value={formData.itemName} placeholder="Enter folder name" onChange={handleInputChange}/>
                            {nameErrorMessage && <p className="text-danger mt-2">{ nameErrorMessage}</p>}
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formGroupPassword">
                            <Form.Label>Folder Details</Form.Label>
                            <Form.Control as="textarea" maxLength={1000} name="itemShortDesc" value={formData.itemShortDesc} placeholder="Write a description of a folder" style={{ height: '100px' }} onChange={handleInputChange}/>
                            <p className="text-end">Total: 1000 characters</p>
                            {descriptionErrorMessage && <p className="text-danger mt-2">{ descriptionErrorMessage }</p>}
                        </Form.Group>
                    </Col>
                </Row>  
                <Row>
                    <Col className="text-end mt-3">
                        <Button variant="default" onClick={closeModal}>Cancel</Button>
                        <Button variant="primary" className="btn-round" onClick={handleSave} type="submit">Update</Button>
                    </Col>
                </Row>
            </Form>
        </ModalCommon>
    );
}

export default ModalFolder;